import React, { FC } from 'react'
import isNil from 'lodash/isNil'

type BorderType = 'danger' | 'warning' | 'basic' | 'default'

export type CardProps = {
  onClick?: (event: React.MouseEvent) => void
  borderType?: BorderType
  cy?: string
  testid?: string
  className?: string
  id: string
}

const getBorderClasses = (borderType?: BorderType) => {
  const baseBorderClasses = `br3-ns b--solid bh-0-s`
  const baseColoredBorderClasses = `b-medium-ns bt-medium-s`
  switch (borderType) {
    case 'danger':
      return `${baseBorderClasses} ${baseColoredBorderClasses} product-summary__card-danger b--danger hover-b--danger bb-thin-s bb--muted-4-s`
    case 'warning':
      return `${baseBorderClasses} ${baseColoredBorderClasses} product-summary__card-warning b--warning hover-b--warning bw0 bw1-ns`
    case 'basic':
      return `${baseBorderClasses} b--muted-4 hover-b--muted-3-ns b-thin-ns bt-thin-s bb-thin-s b-thin-ns`
    case 'default':
      return `br3 b--solid b--muted-4 b-thin `
    default:
      return `${baseBorderClasses} b--muted-4 hover-b--muted-3-ns b-thin-ns bt-thin-s bb-0-s b-thin-ns`
  }
}

export const Card: FC<CardProps> = ({
  onClick,
  borderType,
  children,
  id,
  cy,
  className,
}) => {
  const getExtraClasses = () => {
    const isClickable = !isNil(onClick)
    const borderClasses = getBorderClasses(borderType)
    const hoverClasses = 'pointer'

    if (borderType !== 'basic' && borderType !== 'default') {
      if (isClickable) {
        return `${hoverClasses} ${borderClasses}`
      }
      return ''
    }
    return getBorderClasses(borderType)
  }
  const extraClasses = getExtraClasses()
  return (
    <div
      id={id}
      className={`bg-white ${extraClasses} ${className || ''} `}
      data-cy={cy}
      onClick={onClick}
    >
      {children}
    </div>
  )
}
